<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true">X</ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center">REPLAY</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="video-section ion-padding">
  <div>

    <p *ngIf="track" class="tw-text-[14px] tw-text-center tw-pb-[10px]">
      {{ track }} - {{ breed }} - Race {{ race }} <br/>
      {{ date | dateFormat: 'MM-DD-YYYY' }}
    </p>

    <video
      #videoPlayer
      id="replyVideo"
      class="video-js vjs-default-skin"
      loop
      autoplay
      controls
      preload="auto"
      data-setup='{}'
      width="100%"
      height="243"
      padding="0"
    >
      <!-- <source [src]="safeUrl" type="application/x-mpegURL" /> -->
    </video>

  </div>
</ion-content>
